var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchivementActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7578 19.8486H13.7578V16.8486L12.7578 15.8486L11.7578 16.8486V19.8486H10.7578C9.65781 19.8486 8.75781 20.7486 8.75781 21.8486V22.8486H16.7578V21.8486C16.7578 21.3182 16.5471 20.8095 16.172 20.4344C15.797 20.0593 15.2882 19.8486 14.7578 19.8486Z",
    fill: "#53B7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7578 2.18652L14.4417 7.3689H19.8907L15.4823 10.5718L17.1662 15.7542L12.7578 12.5513L8.34942 15.7542L10.0333 10.5718L5.62489 7.3689H11.074L12.7578 2.18652Z",
    fill: "#53B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchivementActive);
export default __webpack_public_path__ + "static/media/AchivementActive.b32d4f2f14299546671ca336f0521a98.svg";
export { ForwardRef as ReactComponent };